import DxButton from "devextreme-vue/button";
import DxList from 'devextreme-vue/list';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

import { masterService } from '../../../services/master.service';
import { workerService } from '../../../services/worker.service';
import { authService } from '../../../services/auth.service';

import notify from 'devextreme/ui/notify'

const changeLocationPath = "/change-location";

export default {
  name: "login",
  data() {
    return {
      visibleLoadPanel: false,
      title: process.env.VUE_APP_PROJECT_NAME,
      currenPath: "select",
      dataSource: [],
      beforeToken: "",
      currentLocation: {},
      contentClass: "content-block-padding"
    };
  },
  
  created() {
    if (this.$store.state.locations.length != 1) {
      if (this.$route.path == changeLocationPath) {
        this.currenPath = "change";
        this.contentClass = "responsive-paddings dx-card"
      }
      this.dataSource = this.$store.state.locations;
    } else {
      this.$router.push("/home");
    }
  },
  methods: {
    onItemClick(e) {
      let self = this;
      self.visibleLoadPanel = true
      self.beforeToken = self.$store.state.token

      // トークンを再作成する
      authService.selectLocation(e.itemData.workerId)
      .then(
        success => {
          if (success.messageType == 1) {
            self.currentLocation = e.itemData

            self.$store.commit({
              type: 'setToken',
              token: success.content.token
            });

            self.getWorker(self);
          } else {
            self.visibleLoadPanel = false

            self.showMessage(success.message, 'error');
          }
        },
        error => {
          self.visibleLoadPanel = false

          console.log(error)
        }
      );
    },
    getWorker(self) {
      workerService.getWorker()
        .then(
          success => {
            if (success.messageType == 1) {
              self.getConstant(self, success.content)
            } else {
              self.showMessage(success.message, 'error');

              self.$store.commit(
                {
                  type: 'logout',
                })

              self.visibleLoadPanel = false
            }
          },
          error => {
            self.visibleLoadPanel = false
            this.resetStore(self);

            console.log(error)
          }
        );
    },
    getConstant(self, worker) {
      let promiseGetShiftChangeAutoMsg = masterService.getShiftChangeAutoMsg()
      let promiseGetWorkSheetLimitDays = masterService.getWorkSheetLimitDays(worker.fcId)
      let promiseGetShiftChangeLimitDays = masterService.getShiftChangeLimitDays(worker.fcId)
      let promiseGetDesiredShiftMsg = masterService.getDesiredShiftMsg(worker.fcId)
      let promiseGetWorkerNumbers = masterService.getWorkerNumbers(worker.locationId)
      let promiseGetAppUpdateUserId = masterService.getAppUpdateUserId()
      let promiseGetWorksheetTimeUnit = masterService.getWorksheetTimeUnit(worker.locationId)

      Promise.all(
        [promiseGetShiftChangeAutoMsg
          , promiseGetWorkSheetLimitDays
          , promiseGetShiftChangeLimitDays
          , promiseGetDesiredShiftMsg
          , promiseGetWorkerNumbers
          , promiseGetAppUpdateUserId
          , promiseGetWorksheetTimeUnit
        ])
        .then((results) => {

          if (results[0].messageType == 1
            && results[1].messageType == 1
            && results[2].messageType == 1
            && results[3].messageType == 1
            && results[4].messageType == 1
            && results[5].messageType == 1) {

            // stateをクリア
            self.$store.commit({
              type: "resetState",
            });
        
            // storeに保存する
            self.$store.commit(
              {
                type: 'setWorker',
                worker: worker,
              })
            self.$store.commit(
              {
                type: 'setConstantShiftChangeAutoMsg',
                shiftChangeAutoMsg: results[0].content.shiftChangeAutoMsg,
              })
            self.$store.commit(
              {
                type: 'setConstantWorkSheetLimitDays',
                closingTime: results[1].content.closingTime,
                maxOverTime: results[1].content.maxOverTime,
              })
            self.$store.commit(
              {
                type: 'setConstantShiftChangeLimitDays',
                shiftChangeLimitDays: results[2].content.shiftChangeLimitDay,
              })
            self.$store.commit(
              {
                type: 'setConstantDesiredShiftMsg',
                desiredShiftMsg: results[3].content.desiredShiftMsg,
                desiredShiftCode: results[3].content.desiredShiftCode,
              })
            self.$store.commit(
              {
                type: 'setConstantWorkerNumbers',
                workerNumbers: results[4].content.workNumbers,
              })
            self.$store.commit(
              {
                type: 'setConstantAppUpdateUserId',
                appUpdateUserId: results[5].content.appUpdateUserId,
              })
            self.$store.commit(
              {
                type: 'setWorksheetTimeUnit',
                worksheetTimeUnit: results[6].content,
              })
            self.$store.commit(
              {
                type: 'setCurrentLocation',
                currentLocation: self.currentLocation,
              });
  
            // ホーム画面に遷移する
            if (self.$route.query.redirect != changeLocationPath) {
              self.$router.push(self.$route.query.redirect || "/home");
            } else {
              self.$router.push("/home");
            }
          } else {
            // エラーメッセージを表示する
            if (results[0].messageType == 0){
              self.showMessage(results[0].message, 'error');
            } else if (results[1].messageType == 0){
              self.showMessage(results[1].message, 'error');
            } else if (results[2].messageType == 0){
              self.showMessage(results[2].message, 'error');
            } else if (results[3].messageType == 0){
              self.showMessage(results[3].message, 'error');
            } else if (results[4].messageType == 0){
              self.showMessage(results[4].message, 'error');
            } else if (results[5].messageType == 0){
              self.showMessage(results[5].message, 'error');
            } 
          }

          self.visibleLoadPanel = false

        }).catch((errors) => {

          self.visibleLoadPanel = false
          this.resetStore(self);
            
          console.log(errors)
        })
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)

      if (this.currenPath == "change") {
        this.resetStore(this);
      } else {
        this.$store.commit({
          type: 'setToken',
          token: ""
        });
        this.$router.push({ name : "login-form" });
      }
    },
    resetStore(self) {
      self.$store.commit({
        type: 'setToken',
        token: this.beforeToken
      });
    },
  },
  components: {
    DxButton,
    DxLoadPanel,
    DxList
  }
};